/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Europe_DescriptionInputs */

const bn_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একটি সম্পূর্ণ সেট হিসাবে সম্পূর্ণ ইউরোপীয় অঞ্চল।`)
};

const de_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die gesamte europäische Region als Komplettset.`)
};

const el_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η πλήρης ευρωπαϊκή περιοχή ως ένα πλήρες σύνολο.`)
};

const en_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The full European region as one complete set.`)
};

const es_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda la región europea como un conjunto completo.`)
};

const fr_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute l’Europe dans un ensemble complet.`)
};

const hi_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपूर्ण यूरोपीय क्षेत्र एक पूर्ण सेट के रूप में।`)
};

const hu_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A teljes európai régió egy teljes készletként.`)
};

const id_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seluruh wilayah Eropa sebagai satu set lengkap.`)
};

const it_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intera regione europea come un insieme completo.`)
};

const ja_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヨーロッパ地域全体を 1 つの完全なセットとして。`)
};

const ko_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 유럽 지역이 하나의 완전한 세트로 제공됩니다.`)
};

const nl_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De volledige Europese regio als één complete set.`)
};

const pl_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały region europejski jako jeden kompletny zestaw.`)
};

const pt_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda a região europeia como um conjunto completo.`)
};

const ru_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь европейский регион как один комплект.`)
};

const sv_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hela den europeiska regionen som en komplett uppsättning.`)
};

const tr_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam bir set olarak tüm Avrupa bölgesi.`)
};

const uk_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повний європейський регіон як єдиний комплект.`)
};

const vi_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toàn bộ khu vực Châu Âu thành một bộ hoàn chỉnh.`)
};

const zh_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整个欧洲地区作为一个完整的集合。`)
};

const zh_hant_intro_region_europe_description = /** @type {(inputs: Intro_Region_Europe_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整個歐洲地區作為一個完整的集合。`)
};

/**
* | output |
* | --- |
* | "The full European region as one complete set." |
*
* @param {Intro_Region_Europe_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_europe_description = /** @type {((inputs?: Intro_Region_Europe_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Europe_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_europe_description(inputs)
	if (locale === "de") return de_intro_region_europe_description(inputs)
	if (locale === "el") return el_intro_region_europe_description(inputs)
	if (locale === "en") return en_intro_region_europe_description(inputs)
	if (locale === "es") return es_intro_region_europe_description(inputs)
	if (locale === "fr") return fr_intro_region_europe_description(inputs)
	if (locale === "hi") return hi_intro_region_europe_description(inputs)
	if (locale === "hu") return hu_intro_region_europe_description(inputs)
	if (locale === "id") return id_intro_region_europe_description(inputs)
	if (locale === "it") return it_intro_region_europe_description(inputs)
	if (locale === "ja") return ja_intro_region_europe_description(inputs)
	if (locale === "ko") return ko_intro_region_europe_description(inputs)
	if (locale === "nl") return nl_intro_region_europe_description(inputs)
	if (locale === "pl") return pl_intro_region_europe_description(inputs)
	if (locale === "pt") return pt_intro_region_europe_description(inputs)
	if (locale === "ru") return ru_intro_region_europe_description(inputs)
	if (locale === "sv") return sv_intro_region_europe_description(inputs)
	if (locale === "tr") return tr_intro_region_europe_description(inputs)
	if (locale === "uk") return uk_intro_region_europe_description(inputs)
	if (locale === "vi") return vi_intro_region_europe_description(inputs)
	if (locale === "zh") return zh_intro_region_europe_description(inputs)
	return zh_hant_intro_region_europe_description(inputs)
});